import wrappedAxios from './wrappedAxios';
import { HOTELS_API_URL } from 'config';

const checkVoucher = async ({ voucherCode, totalPayableAtBooking, propertyId }) => {
  const response = await wrappedAxios({
    url: `${HOTELS_API_URL}/vouchers/check`,
    method: 'POST',
    data: {
      code: voucherCode,
      bookingValue: totalPayableAtBooking.toNumber(),
      propertyId: parseInt(propertyId),
    },
  });

  return response.data;
};

export default checkVoucher;
